export const checkIsProbabilityValid = (value?: number) => {
  return value !== undefined && value <= 100 && value >= 0;
};
